<script setup>

const modelValue = defineModel()

const { theme } = defineProps({
    theme: {
        type: String,
        default: 'light'
    },
    header: {
        type: String,
        default: 'Местоположение объекта'
    }
})

const isVisible = ref(false)
const zoom = ref(15)
const center = computed(() => {
    if( modelValue.value && parseFloat( modelValue.value.lat ) > 0 && parseFloat( modelValue.value.lon ) > 0 ){
        // console.log('offer / map', [parseFloat( modelValue.value.lat ), parseFloat( modelValue.value.lon )]);
        return [parseFloat( modelValue.value.lat ), parseFloat( modelValue.value.lon )]
    }else{
        // console.log('offer / map', 'default', modelValue.value);
        return [36, 53]
    }
})

import {
    YandexMap,
    YandexMapControls,
    YandexMapDefaultMarker,
    YandexMapDefaultFeaturesLayer,
    YandexMapDefaultSchemeLayer,
    YandexMapZoomControl,
} from "vue-yandex-maps";

const isPanoramaSupported = ref( true )


onMounted( () => {
    isVisible.value = true   
    setTimeout( () => {
        if( import.meta.client ){
            var pano_container = 'bcpanoram';
            if( ymaps ){
                ymaps.ready(function () {
                    console.log('bcpanoram ymaps.ready', 'OK', center.value);
                    // Для начала проверим, поддерживает ли плеер браузер пользователя.
                    if (!ymaps.panorama.isSupported()) {
                        isPanoramaSupported.value = false
                        // Если нет, то просто ничего не будем делать.
                        return;
                    }
                    // Ищем панораму в переданной точке.
                    ymaps.panorama.locate( center.value ).done(function (panoramas) {
                        // Убеждаемся, что найдена хотя бы одна панорама.
                        console.log('bcpanoram done' , panoramas);
                        if (panoramas.length > 0)
                        {
                            // Создаем плеер с одной из полученных панорам.
                            var player = new ymaps.panorama.Player(
                                pano_container,
                                // Панорамы в ответе отсортированы по расстоянию
                                // от переданной в panorama.locate точки. Выбираем первую,
                                // она будет ближайшей.
                                panoramas[0],
                                // Зададим направление взгляда, отличное от значения
                                // по умолчанию.
                                //{ direction: [256, 16] }
                            );
                        }
                    },function (error) {
                        console.log('bcpanoram error', error);
                        // Если что-то пошло
                        isPanoramaSupported.value = false
                    });
                });
            }
        }
    }, 2000);
})

</script>
<template>
    <div v-if="isPanoramaSupported && isVisible" >
        <div id="bcpanoram" style="width: 100%; height: 100%" ></div>
    </div>
    <div v-else>
        <div class="flex items-center justify-center w-full h-full bg-gray-150 font-normal text-lg">
            <p>Панорама недоступна</p>
        </div>
    </div>
</template>

<style>

ymaps {
  box-sizing: content-box !important;
}

</style>